import Image from '../Imagenes/exe_quito.jpg'
import Image1 from '../Imagenes/IMG_38211.JPG'
import SectionHead from './SectionHead'
import { GiCutDiamond } from 'react-icons/gi'
import { about } from '../data'
import Card from '../UI/Card'
import './Aboutc.css'
const About = () => {
  return (
    <section className="about">
      <div className="container about-container">

        <div className="about-left">
          <AboutImage src={Image} />
          <AboutImage src={Image1} />
        </div>

        <div className="about-right">
          <SectionHead icon={<GiCutDiamond />} title="Salas de Velación" />

          <p className="about-text">
           Exequiales Iess es una compañía del Instituto Ecuatoriano de Seguridad Social (IESS) 
           que ofrece servicios funerarios mediante el uso del Fondo de Auxilio para Funerales.
            Todos los pensionistas de jubilación, pensionistas de montepío y afiliados al IESS que 
            hayan realizado al menos 6 aportes mensuales en los 12 meses previos a su fallecimiento 
            tienen derecho a acceder a este fondo.
          </p>

          <div className="about-values">
            {about.map(({ id, title, desc }) => (
              <Card key={id}>
                <h4 className="card-title">{title}</h4>
                <small>{desc}</small>
              </Card>
            ))}
          </div>
        </div>

      </div>
    </section>
  )
}

const AboutImage = ({ src }) => (
  <div className="about-image">
    <img src={src} alt="Imagen institucional" />
  </div>
)

export default About
